import { Box, alpha } from '@mui/material';
import React from 'react';

interface DragPreviewChipProps {
  label: string;
}

export const DragPreviewChip: React.FC<DragPreviewChipProps> = ({ label }) => (
  <Box
    sx={theme => ({
      padding: '4px 8px',
      background: alpha(theme.palette.primary.main, 0.15),
      border: `1px solid ${alpha(theme.palette.primary.main, 0.6)}`,
      borderRadius: '4px',
      fontFamily: 'Roboto',
      fontSize: '14px',
      color: 'inherit',
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
    })}
  >
    {label}
  </Box>
);
